__turbopack_context__.v({
  "image": "NudgeCard-module__TM3ooa__image",
  "root": "NudgeCard-module__TM3ooa__root",
  "text": "NudgeCard-module__TM3ooa__text",
});
